<script lang="ts" setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useSdk } from '~/sdk';
import { useStorage } from '@vueuse/core';
import { useCountries } from '~/composables/useCountries';
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogAction,
  AlertDialogCancel,
} from '@/components/ui/alert-dialog';

const router = useRouter();
const countryCookie = useCookie('vsf-country');
const cookieId = useCookie('geolocation_id');
const cookieCode = useCookie('geolocation_code');
const answered = useStorage('geolocation_answered', () => false, sessionStorage);
const { data: countries } = useCountries();

const currentCountry = computed(() => {
  return countries.value?.find((country) => country.id_country == countryCookie?.value);
});

const { data } = useAsyncData(async () => {
  if (!cookieCode.value) return null;
  return await useSdk().commerce.getCountry({ code: cookieCode.value });
});

const switchCountry = () => {
  answered.value = true;
  countryCookie.value = cookieId.value;
  router.replace({ query: { id_country: cookieId.value } }).then(() => location.reload());
};
</script>

<template>
  <AlertDialog :open="!!(!answered && cookieId != countryCookie && data && currentCountry)">
    <!-- trigger is optional since we open programmatically -->
    <AlertDialogContent class="max-w-lg">
      <h3 class="text-lg font-semibold">{{ $t('Change Country') }}</h3>
      <p class="mt-2 text-sm">
        {{
          $t('geoNotice', {
            country: data?.name || '',
            current: currentCountry?.name || '',
          })
        }}
      </p>      <div class="mt-4 flex justify-end space-x-2">
        <AlertDialogCancel class="px-4 py-2" @click="answered = true">{{ $t('Cancel') }}</AlertDialogCancel>
        <AlertDialogAction class="px-4 py-2 bg-blue-600 text-white" @click="switchCountry" v-if="data">
          {{ $t('Switch to {country}', { country: data?.name || '' }) }}
        </AlertDialogAction>
      </div>
    </AlertDialogContent>
  </AlertDialog>
</template>
